import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import HOC from "../../../components/HOC";
import InboxDetailWarehouse from "../../../components/screen/centralWarehouse/inbox/InboxDetailWarehouse";
import { theme } from "../../../components/constants/muiTheme";

const DetailInboxWarehousePage = ({ type }) => {
  return (
    <div className="">
      <PageTemplate
        header="Detail Inbox"
        mainComponent={
          <ThemeProvider theme={theme}>
            <InboxDetailWarehouse type={type} />
          </ThemeProvider>
        }
        pageRole={type === 1 ? 39 : 40}
      />
    </div>
  );
};

export default HOC(DetailInboxWarehousePage);
